export const store = {
  dashboard: [
    { name: 'Category', url: 'ca' },
    { name: 'Sport', url: 'sp' },
    { name: 'Tournament', url: 'to' }
  ]
};